<template>
    <div class="SettingFormBox RLayoutBox">
        <el-form :model="form" status-icon :rules="rules" ref="form" label-position="right" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="选择仓库" prop="WarehouseId">
                        <RemoteSelect v-model="form.WarehouseId" url="AccessoryEntryRecords/GetWareHouseList"
                            code="WarehouseId" name="WarehouseName" placeholder="选择仓库" >
                        </RemoteSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入场编号" prop="Source">
                        <RemoteSelect v-model="form.Source" url="AccessoryEntryRecords/GetRegistrationNum"
                            code="RegistrationNum" name="RegistrationNum" placeholder="入场编号" :multiple="true">
                        </RemoteSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="配件名称" prop="AccessoryName">
                        <el-input v-model="form.AccessoryName" placeholder="配件名称" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="规格型号" prop="Specification">
                        <el-input v-model="form.Specification" placeholder="规格型号" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="数量" prop="Quantity">
                        <el-input-number v-model="form.Quantity" @change="handleChange" :min="1"  placeholder="数量"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="单位" prop="Unit">
                        <el-input v-model="form.Unit" placeholder="单位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="重量" prop="Weight">
                        <el-input v-model="form.Weight" placeholder="重量（kg）" ></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
            <el-footer>
        <div class="FromElRowMargin">
            <el-button type="primary" @click="save" :loading="loading">保 存</el-button>
          <el-button
            type="canale"
            size="medium"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-footer>
    </div>
    </template>
    
<script>
export default {
    props: ["item"],
    components: {
    },
    data() {
        return {
            loading: false,
            isable: true,
            form: {},
            rules: {
                WarehouseId: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Source: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                AccessoryName: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Specification: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Quantity: [
                    {
                        required: true,
                        message: "不可为空",
                        ...this.$g.validNumber,
                    },
                ],
                Unit: [
                    {
                        required: true,
                        message: "不可为空",
                    },
                ],
                Weight: [
                    {
                        required: true,
                        message: "不可为空",
                        ...this.$g.validNumber,
                    },
                ],
            },
        };
    },
    computed: {
    },
    watch: {
        item: {
            handler: function (v) {
                if (v.EntryId) {
                    this.$get("AccessoryEntryRecords/GetModel", {
                        EntryId: v.EntryId,
                    }).then((r) => {
                        r.Result.Source=r.Result.Source.split(',')
                        this.init({ ...r.Result });
                    });
                } else {
                    this.init({});
                }
            },
        },
    },
    methods: {
        init(form) {
            this.form = { ...form };
            if (this.$refs["form"]) {
                this.$refs["form"].resetFields();
            }
        },
        save() {
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return;
                }
                let params = { ...this.form };
                params.Source=params.Source.join(',')
                this.loading = true;
                if (this.isEdit) {
                    this.$post("AccessoryEntryRecords/Edit", params)
                        .then((r) => {
                            this.$message.success("修改成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                else {
                    this.$post("AccessoryEntryRecords/Add", params)
                        .then((r) => {
                            this.$message.success("添加成功");
                            this.visible = false;
                            this.$emit("success");
                        })
                }
                this.loading = false;
            });
        },
        boardListPhotosSuccess(uid) {
            this.$set(this.form, "boardListPhotos", uid);
        },
        boardListPhotosError() {
            this.$set(this.form, "boardListPhotos", '');
        },
        handleChange(values) {
            console.log('1111',values)
        },
        reset(){

        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/themes/common";

h4 {
    margin-top: 10px;
    @include font_color("text-color2");
}
</style>